"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingQuotaDtoSchema = void 0;
const zod_1 = require("zod");
// An explicit z.ZodObject<Shape> annotation truncates the generated .d.ts to a partial generic;
// consumers with strictNullChecks:false (e.g. routing-functions) then recompute Output/Input and
// every field turns optional. Leave this to inference so the compiled .d.ts bakes in the full,
// consumer-proof type.
exports.BookingQuotaDtoSchema = zod_1.z.object({
    maxBookingsPerMonth: zod_1.z.number().int().nonnegative(),
    usedThisMonth: zod_1.z.number().int().nonnegative(),
});
//# sourceMappingURL=bookingQuota.js.map